import { LoadingButton } from "@mui/lab";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  DialogContentText,
} from "@mui/material";


export default function TodoCancelDialog({ isOpen, closeDialog, cancel, isSubmitting}) {

  const cancelTodo = async () => {
    await cancel();
  }

  return (
    <Dialog open={isOpen} onClose={closeDialog} fullWidth maxWidth="xs">
      <DialogTitle sx={{ mb: 2 }}>
        투두를 미완료로 되돌릴까요?
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          변경한 데일리 투두는 크루에도 동일하게 보여집니다.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <LoadingButton
          size="large"
          sx={{ px: 4 }}
          loading={isSubmitting}
          onClick={closeDialog}
        >
          취소
        </LoadingButton>
        <LoadingButton
          size="large"
          sx={{ px: 4 }}
          loading={isSubmitting}
          variant="contained"
          onClick={cancelTodo}
        >
          되돌리기
        </LoadingButton>
      </DialogActions>
    </Dialog>
  )
}